export default __webpack_public_path__ + "static/media/pic4.69b1f985.jpg";